import React, { Component } from "react";

export default class Skills extends Component {
  render() {
    return (
      <div>
        <section className="colorlib-skills" data-section="skills">
          <div className="colorlib-narrow-content">
            <div className="row">
              <div
                className="col-md-6 col-md-offset-3 col-md-pull-3 animate-box fadeInLeft animated"
                data-animate-effect="fadeInLeft"
              >
                <span className="heading-meta">My Specialty</span>
                <h2 className="colorlib-heading animate-box fadeInUp animated">
                  My Skills
                </h2>
              </div>
            </div>
            <div className="row">
              <div
                className="col-md-12 animate-box fadeInLeft animated"
                data-animate-effect="fadeInLeft"
              >
                <p>
                  There is always something new to learn, I am constantly
                  looking how to overcome my weaknesses and interact in a better
                  way with my colleagues.
                </p>
              </div>
              <div
                className="col-md-6 animate-box fadeInLeft animated"
                data-animate-effect="fadeInLeft"
              >
                <div className="progress-wrap">
                  <h3>Linux</h3>
                  <div className="progress">
                    <div
                      className="progress-bar color-1"
                      role="progressbar"
                      aria-valuenow="50"
                      aria-valuemin="0"
                      aria-valuemax="100"
                      style={{ width: "50%" }}
                    >
                      <span>50%</span>
                    </div>
                  </div>
                </div>
              </div>
              <div
                className="col-md-6 animate-box fadeInRight animated"
                data-animate-effect="fadeInRight"
              >
                <div className="progress-wrap">
                  <h3>jQuery</h3>
                  <div className="progress">
                    <div
                      className="progress-bar color-2"
                      role="progressbar"
                      aria-valuenow="60"
                      aria-valuemin="0"
                      aria-valuemax="100"
                      style={{ width: "60%" }}
                    >
                      <span>60%</span>
                    </div>
                  </div>
                </div>
              </div>
              <div
                className="col-md-6 animate-box fadeInLeft animated"
                data-animate-effect="fadeInLeft"
              >
                <div className="progress-wrap">
                  <h3>HTML5</h3>
                  <div className="progress">
                    <div
                      className="progress-bar color-3"
                      role="progressbar"
                      aria-valuenow="85"
                      aria-valuemin="0"
                      aria-valuemax="100"
                      style={{ width: "85%" }}
                    >
                      <span>85%</span>
                    </div>
                  </div>
                </div>
              </div>
              <div
                className="col-md-6 animate-box fadeInRight animated"
                data-animate-effect="fadeInRight"
              >
                <div className="progress-wrap">
                  <h3>React</h3>
                  <div className="progress">
                    <div
                      className="progress-bar color-4"
                      role="progressbar"
                      aria-valuenow="75"
                      aria-valuemin="0"
                      aria-valuemax="100"
                      style={{ width: "75%" }}
                    >
                      <span>75%</span>
                    </div>
                  </div>
                </div>
              </div>
              <div
                className="col-md-6 animate-box fadeInLeft animated"
                data-animate-effect="fadeInLeft"
              >
                <div className="progress-wrap">
                  <h3>AWS</h3>
                  <div className="progress">
                    <div
                      className="progress-bar color-5"
                      role="progressbar"
                      aria-valuenow="40"
                      aria-valuemin="0"
                      aria-valuemax="100"
                      style={{ width: "40%" }}
                    >
                      <span>40%</span>
                    </div>
                  </div>
                </div>
              </div>
              <div
                className="col-md-6 animate-box fadeInRight animated"
                data-animate-effect="fadeInRight"
              >
                <div className="progress-wrap">
                  <h3>Javascript</h3>
                  <div className="progress">
                    <div
                      className="progress-bar color-6"
                      role="progressbar"
                      aria-valuenow="80"
                      aria-valuemin="0"
                      aria-valuemax="100"
                      style={{ width: "80%" }}
                    >
                      <span>80%</span>
                    </div>
                  </div>
                </div>
              </div>
              <div
                className="col-md-6 animate-box fadeInLeft animated"
                data-animate-effect="fadeInLeft"
              >
                <div className="progress-wrap">
                  <h3>Node.js</h3>
                  <div className="progress">
                    <div
                      className="progress-bar color-6"
                      role="progressbar"
                      aria-valuenow="45"
                      aria-valuemin="0"
                      aria-valuemax="100"
                      style={{ width: "45%" }}
                    >
                      <span>45%</span>
                    </div>
                  </div>
                </div>
              </div>
              <div
                className="col-md-6 animate-box fadeInRight animated"
                data-animate-effect="fadeInRight"
              >
                <div className="progress-wrap">
                  <h3>PHP</h3>
                  <div className="progress">
                    <div
                      className="progress-bar color-5"
                      role="progressbar"
                      aria-valuenow="80"
                      aria-valuemin="0"
                      aria-valuemax="100"
                      style={{ width: "80%" }}
                    >
                      <span>80%</span>
                    </div>
                  </div>
                </div>
              </div>
              <div
                className="col-md-6 animate-box fadeInLeft animated"
                data-animate-effect="fadeInLeft"
              >
                <div className="progress-wrap">
                  <h3>GIT</h3>
                  <div className="progress">
                    <div
                      className="progress-bar color-4"
                      role="progressbar"
                      aria-valuenow="80"
                      aria-valuemin="0"
                      aria-valuemax="100"
                      style={{ width: "80%" }}
                    >
                      <span>80%</span>
                    </div>
                  </div>
                </div>
              </div>
              <div
                className="col-md-6 animate-box fadeInRight animated"
                data-animate-effect="fadeInRight"
              >
                <div className="progress-wrap">
                  <h3>SCRUM</h3>
                  <div className="progress">
                    <div
                      className="progress-bar color-3"
                      role="progressbar"
                      aria-valuenow="80"
                      aria-valuemin="0"
                      aria-valuemax="100"
                      style={{ width: "80%" }}
                    >
                      <span>80%</span>
                    </div>
                  </div>
                </div>
              </div>
              <div
                className="col-md-6 animate-box fadeInLeft animated"
                data-animate-effect="fadeInLeft"
              >
                <div className="progress-wrap">
                  <h3>JIRA</h3>
                  <div className="progress">
                    <div
                      className="progress-bar color-2"
                      role="progressbar"
                      aria-valuenow="80"
                      aria-valuemin="0"
                      aria-valuemax="100"
                      style={{ width: "80%" }}
                    >
                      <span>80%</span>
                    </div>
                  </div>
                </div>
              </div>
              <div
                className="col-md-6 animate-box fadeInRight animated"
                data-animate-effect="fadeInRight"
              >
                <div className="progress-wrap">
                  <h3>Powershell</h3>
                  <div className="progress">
                    <div
                      className="progress-bar color-1"
                      role="progressbar"
                      aria-valuenow="50"
                      aria-valuemin="0"
                      aria-valuemax="100"
                      style={{ width: "50%" }}
                    >
                      <span>50%</span>
                    </div>
                  </div>
                </div>
              </div>
              <div
                className="col-md-6 animate-box fadeInLeft animated"
                data-animate-effect="fadeInLeft"
              >
                <div className="progress-wrap">
                  <h3>SQL</h3>
                  <div className="progress">
                    <div
                      className="progress-bar color-1"
                      role="progressbar"
                      aria-valuenow="50"
                      aria-valuemin="0"
                      aria-valuemax="100"
                      style={{ width: "50%" }}
                    >
                      <span>50%</span>
                    </div>
                  </div>
                </div>
              </div>
              <div
                className="col-md-6 animate-box fadeInRight animated"
                data-animate-effect="fadeInRight"
              >
                <div className="progress-wrap">
                  <h3>MySQL</h3>
                  <div className="progress">
                    <div
                      className="progress-bar color-6"
                      role="progressbar"
                      aria-valuenow="50"
                      aria-valuemin="0"
                      aria-valuemax="100"
                      style={{ width: "50%" }}
                    >
                      <span>50%</span>
                    </div>
                  </div>
                </div>
              </div>
              <div
                className="col-md-6 animate-box fadeInLeft animated"
                data-animate-effect="fadeInLeft"
              >
                <div className="progress-wrap">
                  <h3>Gatsby.js</h3>
                  <div className="progress">
                    <div
                      className="progress-bar color-5"
                      role="progressbar"
                      aria-valuenow="40"
                      aria-valuemin="0"
                      aria-valuemax="100"
                      style={{ width: "40%" }}
                    >
                      <span>40%</span>
                    </div>
                  </div>
                </div>
              </div>
              <div
                className="col-md-6 animate-box fadeInLeft animated"
                data-animate-effect="fadeInLeft"
              >
                <div className="progress-wrap">
                  <h3>C#</h3>
                  <div className="progress">
                    <div
                      className="progress-bar color-2"
                      role="progressbar"
                      aria-valuenow="30"
                      aria-valuemin="0"
                      aria-valuemax="100"
                      style={{ width: "30%" }}
                    >
                      <span>30%</span>
                    </div>
                  </div>
                </div>
              </div>
              <div
                className="col-md-6 animate-box fadeInLeft animated"
                data-animate-effect="fadeInLeft"
              >
                <div className="progress-wrap">
                  <h3>Storybook</h3>
                  <div className="progress">
                    <div
                      className="progress-bar color-4"
                      role="progressbar"
                      aria-valuenow="45"
                      aria-valuemin="0"
                      aria-valuemax="100"
                      style={{ width: "45%" }}
                    >
                      <span>40%</span>
                    </div>
                  </div>
                </div>
              </div>
              <div
                className="col-md-6 animate-box fadeInLeft animated"
                data-animate-effect="fadeInLeft"
              >
                <div className="progress-wrap">
                  <h3>RTL</h3>
                  <div className="progress">
                    <div
                      className="progress-bar color-3"
                      role="progressbar"
                      aria-valuenow="45"
                      aria-valuemin="0"
                      aria-valuemax="100"
                      style={{ width: "45%" }}
                    >
                      <span>45%</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <br></br>
        <br></br>
        <br></br>
        <br></br>
        <br></br>
        <br></br>
      </div>
    );
  }
}
